import { ProduktLinie } from "@/model/ProduktLinie";

export class Preise {
  produktLinien: ProduktLinie[];
  produktLinienIndex = 0;

  constructor() {
    this.produktLinien = [new ProduktLinie(), new ProduktLinie(), new ProduktLinie()];
  }
}
